import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { InviteType } from '../../custom-types';
import { DataSourceResponse, Invite } from '../../models';


@Injectable({ providedIn: 'root' })
export class AdminInvitesService extends ApiService {
    endpoint = 'api/adminInvites';

    getInvites(page = 1, pageSize = 10) {
        return this.http.get<DataSourceResponse<Invite>>(`${this.commonBaseURL}/${this.endpoint}?page=${page}&pageSize=${pageSize}`);
    }

    create(type: InviteType, recipient: string, data: string) {
        const payload = { type, recipient, data };
        return this.http.post(`${this.commonBaseURL}/${this.endpoint}`, payload);
    }
}
